import * as angular from 'angular';
import {CommonsConstantsType} from '../../constants/ib-commons-constants';

@Component('ib-ui-flight-card-module', 'ibUiFlightCard', {
    bindings: {
	    flightInfo : '<',
	    separator : '<'
    },
    controllerAs: 'ibUiFlightCardCtrl',
    templateUrl: ['$rootScope', ($rootScope:CommonsRootScope) => {
        return `${$rootScope.routes.templates}ib-ui-flight-card-view.html`;
    }]
}, ['CommonsConstants'], [])
class IbUiFlightCardController implements ng.IController {
    public showDetails: boolean = false;
    public keepCollapseOpen: boolean = false;
    public cssClassMessage: string = '';
    public cssClassDate: string ;
    public flightInfo: UiComponentsModel.FlightCardComponentFlightInfo;
    public separator: boolean;

    constructor (private CommonsConstants: CommonsConstantsType) {
    }

    $onInit ( ) {
        if (angular.isUndefined(this.separator)) {
            this.separator = true;
        }
    }

    $onChanges ( ) {
        if (this.flightInfo && this.flightInfo.flightData  && this.flightInfo.flightData.type === this.CommonsConstants.UICOMPONENT.UI_FLIGHT_CARD.NEW_FLIGHT) {
            this.cssClassMessage = 'ib-ticket-block__flight-info--prev';
            this.cssClassDate = 'ib-ticket-block__date--white';
        }else {
            this.cssClassMessage = 'ib-ticket-block__flight-info--new';
            this.cssClassDate = '';
        }
    }

    getFareIcon = (icon : string) => {
        let type = '';
        switch (icon) {
                case this.CommonsConstants.FARE_ICON.CABINA.CASE:
                    type = this.CommonsConstants.FARE_ICON.CABINA.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.EQMANO.CASE:
                    type = this.CommonsConstants.FARE_ICON.EQMANO.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.EQBODEGA.CASE:
                    type = this.CommonsConstants.FARE_ICON.EQBODEGA.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.ASIENTO.CASE:
                    type = this.CommonsConstants.FARE_ICON.ASIENTO.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.ASIENTOXL.CASE:
                    type = this.CommonsConstants.FARE_ICON.ASIENTOXL.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.CAMBIO.CASE:
                    type = this.CommonsConstants.FARE_ICON.CAMBIO.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.REEMBOLSO.CASE:
                    type = this.CommonsConstants.FARE_ICON.REEMBOLSO.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.CHECKINDESK.CASE:
                    type = this.CommonsConstants.FARE_ICON.CHECKINDESK.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.SALAVIP.CASE:
                    type = this.CommonsConstants.FARE_ICON.SALAVIP.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.FASTTRACK.CASE:
                    type = this.CommonsConstants.FARE_ICON.FASTTRACK.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.TARJEMBANTIC.CASE:
                    type = this.CommonsConstants.FARE_ICON.TARJEMBANTIC.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.EQPPRIOR.CASE:
                    type = this.CommonsConstants.FARE_ICON.EQPPRIOR.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.COMIDA.CASE:
                    type = this.CommonsConstants.FARE_ICON.COMIDA.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.EMBARQUE.CASE:
                    type = this.CommonsConstants.FARE_ICON.EMBARQUE.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.AEROPUERTO.CASE:
                    type = this.CommonsConstants.FARE_ICON.AEROPUERTO.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.AVIOSPLUS.CASE:
                    type = this.CommonsConstants.FARE_ICON.AVIOSPLUS.TYPE;
                    break;
                case this.CommonsConstants.FARE_ICON.PUNTUALIDAD.CASE:
                    type = this.CommonsConstants.FARE_ICON.PUNTUALIDAD.TYPE;
                case this.CommonsConstants.FARE_ICON.FASTLANE.CASE:
                    type = this.CommonsConstants.FARE_ICON.FASTLANE.TYPE;
                    break;
        }
        return type;
    };
}

